import * as React from 'react';
import * as _ from "lodash";
import { DepartmentsMessage, TexBody, IconContainer, Subtitle, TitleButton } from './styles'
import { ReactComponent as IconExclaim } from 'common/images/icon-exclaim.svg'
import { ReactComponent as IconCheck } from 'common/images/icon-check.svg'
import { ReactComponent as IconChecklist } from 'common/images/icon-checklist.svg'
import { DepartmentsButtons } from 'features/Dealers/DealerConfiguration/Departments/Buttons';

export const DepartmentsTitle = (props) => {

    return (

        <TexBody>            
        <IconContainer>{renderIcon()}</IconContainer>
        <Subtitle>           
            <DepartmentsMessage>
                { renderTitle()}
            </DepartmentsMessage>      
            {renderButton()}          
        </Subtitle>
        </TexBody>




       
    )

    function renderIcon(){
        if (props.renderType == 1 ||  props.renderType == 2 || props.renderType == 3)
            return (<IconExclaim></IconExclaim>);
        else if (props.renderType == 4 || props.renderType == 5)
            return (<IconChecklist></IconChecklist>);
        else
            return (<IconCheck></IconCheck>);
    }

    function renderTitle() {
        if (props.renderType == 1)
            return (`No related deparment listing were found in GBP. Contact our support team to get your department listings claimed or linked to your main listing.`)
        else if (props.renderType == 2)
            return (`We found ${props.locations?.locations.length ?? 0} locations in GBP that can be linked but there are currently no departments in the CMS. Please add a department in the \"Departments\" section here.`)
        else if (props.renderType == 3)
            return ('You currently have no CMS departments linked to any GBP listings. To set up your Location Departments, please link them below in \'Link Your Departments\'. Once they are linked, you will be able to access and edit them from the navigation menu.')
        else if (props.renderType == 4)
            return ('You currently have one CMS department linked to a GBP listing. You can associate other departments and listings below.')
        else if (props.renderType == 5)
            return ('You currently have CMS departments linked to a GBP listing. You can associate other departments and listings below.')            
        else
            return ('Success, you\'re all done! You have linked all of your Departments to your GBP listing')

    }

    function renderButton()
    {
        if (props.renderType == 1 ||  props.renderType == 2 )
            return (
                <TitleButton>
                    <DepartmentsButtons
                    renderType={props.renderType}
                    departments={props.departments}
                    onSaveClick={props.onSaveClick}
                    
                    />
                </TitleButton>
            );
    }

}